import React from "react";
import { Globe, MessageCircle, X, ArrowRight, CalendarCheck, CheckCircle2 } from "lucide-react";

export default function BeforeAfter() {
  return (
    <section
      id="before-after"
      data-testid="before-after-section"
      className="section bg-nav-950"
    >
      <div className="container-x">
        <div className="max-w-3xl mx-auto text-center">
          <span className="eyebrow justify-center">
            <span className="h-1.5 w-1.5 rounded-full bg-brand" />
            Before · After
          </span>
          <h2 className="mt-4 h-display text-4xl sm:text-5xl">
            Same traffic.{" "}
            <span className="text-brand">Completely different result.</span>
          </h2>
          <p className="mt-4 text-lg text-nav-300">
            The flow your visitors walk through decides whether they book — or
            ghost.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-2 gap-6 lg:gap-8">
          {/* BEFORE */}
          <div className="relative">
            <div className="absolute -top-3 left-4 z-10 inline-flex items-center gap-2 rounded-full bg-nav-800 text-nav-300 text-xs font-semibold px-3 py-1.5 uppercase tracking-wider border border-nav-700">
              <X className="h-3 w-3" /> Before
            </div>
            <div className="rounded-2xl border border-nav-800 bg-nav-900/70 p-6 sm:p-8">
              <ul className="space-y-4">
                {[
                  { icon: Globe, label: "Discovers you (social, search, referral)", color: "text-nav-300" },
                  { icon: MessageCircle, label: "Sends a DM, email, or text", color: "text-nav-400" },
                  { icon: MessageCircle, label: "Asks: \"How much?\" \"What times?\"", color: "text-nav-400" },
                  { icon: X, label: "You answer hours later — they've moved on", color: "text-red-400" },
                ].map((step, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="grid place-items-center h-9 w-9 rounded-lg bg-nav-800 border border-nav-700 shrink-0">
                      <step.icon className={`h-4 w-4 ${step.color}`} />
                    </span>
                    <div className="flex-1 pt-1.5">
                      <p className="text-sm text-nav-200">{step.label}</p>
                    </div>
                  </li>
                ))}
              </ul>
              <div className="mt-6 pt-5 border-t border-nav-800 flex items-center gap-2 text-sm">
                <X className="h-4 w-4 text-red-400" />
                <span className="text-red-300 font-semibold">
                  Result: Lost visitor, no record, no follow-up
                </span>
              </div>
            </div>
          </div>

          {/* AFTER */}
          <div className="relative">
            <div className="absolute -top-3 left-4 z-10 inline-flex items-center gap-2 rounded-full bg-brand text-white text-xs font-semibold px-3 py-1.5 uppercase tracking-wider">
              <CheckCircle2 className="h-3 w-3" /> After
            </div>
            <div className="rounded-2xl border border-brand/40 bg-nav-900/80 p-6 sm:p-8 shadow-[0_30px_60px_-20px_rgba(91,91,255,0.4)]">
              <ul className="space-y-4">
                {[
                  { icon: Globe, label: "Discovers you (social, search, or referral)", color: "text-brand" },
                  { icon: Globe, label: "Taps your link → lands on a clear funnel", color: "text-brand" },
                  { icon: ArrowRight, label: "Picks a service · sees the price · sees availability", color: "text-brand" },
                  { icon: CalendarCheck, label: "Books on the spot — confirmed instantly", color: "text-emerald-400" },
                ].map((step, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="grid place-items-center h-9 w-9 rounded-lg bg-brand/15 border border-brand/30 shrink-0">
                      <step.icon className={`h-4 w-4 ${step.color}`} />
                    </span>
                    <div className="flex-1 pt-1.5">
                      <p className="text-sm text-white font-medium">{step.label}</p>
                    </div>
                  </li>
                ))}
              </ul>
              <div className="mt-6 pt-5 border-t border-nav-800 flex items-center gap-2 text-sm">
                <CheckCircle2 className="h-4 w-4 text-emerald-400" />
                <span className="text-emerald-300 font-semibold">
                  Result: Booked appointment, in your calendar, paid (or deposit collected)
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
